module.exports = __webpack_public_path__ + "img/f3197b37d4f52a3f3c5d0b8109efa116@2x.4e3b3945.jpg";